@if (loadingService.isLoading()) {
  <div class="loading-overlay" role="status" aria-live="polite">
    <div class="loading-overlay-content">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </div>
}
